exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#gatewaycontainer {\n  padding: 15px;\n  height: 600; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/modules/networking/networking-vc/gateways/listing/gateway-listing.scss
// module id = 2nFs
// module chunks = 0